import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../styles/themes/types';

export default makeStyles((theme: DSTheme) => ({
  signup: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    paddingTop: '50px',

    [theme.breakpoints.up('lg')]: {
      paddingTop: '80px',
    },
  },
  signupDetails: {
    padding: '32px',
    width: '100%',
    margin: 0,

    [theme.breakpoints.up('lg')]: {
      marginLeft: '8vw',
      width: 'fit-content',
    },

    '& p': {
      maxWidth: '519px',
    },
  },
  titleText: {
    color: theme.palette.type === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
    marginBottom: '16px',

    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
  signupImage: {
    width: '100%',
    maxWidth: '525px',
    height: '100%',
    marginTop: '-70px',

    '@media (min-width: 1440px)': {
      margin: 0,
    },
  },
  card: {
    padding: '32px',
    height: 'fit-content',
    backgroundColor: theme.palette.background.elevation1,
    boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
    marginTop: '32px',
    borderRadius: '16px',

    [theme.breakpoints.up('lg')]: {
      marginTop: 0,
      borderRadius: '16px 0px 0px 16px',
    },

    '& input:-internal-autofill-selected,input:-webkit-autofill': {
      boxShadow: `0 0 0px 50px ${theme.palette.background.elevation1} inset`,
    },

    '& h1': {
      color:
        theme.palette.type === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
      maxWidth: '400px',
      marginBottom: '40px',
    },

    '& button': {
      marginTop: '32px',
    },
  },
  signupForm: {
    maxWidth: '449px',
  },
  inputWrapper: {
    width: '100%',
    minHeight: '80px',
  },
  input: {
    color: theme.palette.text.primary,
    borderRadius: '16px',
    borderColor: theme.palette.grey[600],
    borderWidth: '1px',
  },
  inputLabel: {
    color: theme.palette.text.primary,
  },
  termsRow: {
    marginTop: '32px',
    '& a': {
      color: theme.palette.type === 'dark' ? theme.palette.grey[700] : theme.palette.primary.main,
    },
  },
}));
